export const RECAPTCHA_ENTERPRISE = {
    data() {
        return {
            hasErrorCaptcha: false,
        }
    },
    props: {
        config: {
            type: Object,
            validator: function (value) {
                return (
                    value &&
                    value.siteKey &&
                    value.action &&
                    value.VerifyEndpoint &&
                    value.ErrorMessage
                );
            },
        },
    },
    methods: {
        /**
         * Load and get a reCAPTCHA Enterprise token
         * @param {string} action
         * @returns {Promise<string>}
         */
        async getRecaptchaToken(action = "submit") {
            return new Promise((resolve, reject) => {
                if (!window.grecaptcha || !window.grecaptcha.enterprise) {
                    return reject("reCAPTCHA script not loaded");
                }

                window.grecaptcha.enterprise.ready(async () => {
                    try {
                        const token = await window.grecaptcha.enterprise.execute(
                            this.config.siteKey,
                            { action }
                        );
                        resolve(token);
                    } catch (err) {
                        reject(err);
                    }
                });
            });
        },

        /**
         * Validate reCAPTCHA token with backend
         * @param {string} token
         * @returns {Promise<any>}
         */
        async verifyRecaptchaOnServer(token, action) {
            const res = await fetch(this.config.VerifyEndpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ recaptchaToken: token, action }),
            });
            return res.json();
        },

        /**
         * Main method: get token + verify with backend
         * @param {Function} callback - Function to execute after CAPTCHA passes.
         * @param {string} action
         * @returns {Promise<any>}
         */
        async validateRecaptcha(callback, action = this.config.action) {
            try {
                // Validate
                const token = await this.getRecaptchaToken(action);
                const result = await this.verifyRecaptchaOnServer(token, action);

                // Failed?
                if (!result || !result.success) {
                    this.hasErrorCaptcha = true;
                    return result;
                }
                // Success!!! → Run callback
                this.hasErrorCaptcha = false;
                callback();
                return result;
            } catch (error) {
                this.hasErrorCaptcha = true;
                return { success: false, error };
            }
        }
    }
};

export default RECAPTCHA_ENTERPRISE;
